import {
  useIsAndroid,
  useIsDesktop,
  useIsWeb,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Pressable, Text, View} from 'native-base';
import React from 'react';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

import useHover from 'hooks/useHover';
import {useTheme} from 'styled-components/native';

export interface OfferFilterListItemProps {
  title?: string;
  count?: number;
  active?: boolean;
  onPress?: () => void;
  setBottomBorder: boolean;
  disabled: boolean;
  chevronDisabled?: boolean;
}

const OfferFilterListItem: React.FC<OfferFilterListItemProps> = props => {
  const {
    active,
    chevronDisabled = false,
    count,
    disabled,
    onPress,
    setBottomBorder,
    title,
  } = props;
  const theme = useTheme();
  const {athens, caesarRewards, tuna, ghostWhite} = theme.colors;
  const {hovering, handleHoverIn, handleHoverOut} = useHover();
  const isDesktop = useIsDesktop();
  const isAndroid = useIsAndroid();
  const isWeb = useIsWeb();
  const isLongTitle = title && title?.length > 23;

  const getPaddingTop = () => {
    if (isAndroid) {
      // longer titles need topPadding or else they look misaligned
      if (isLongTitle) {
        return 2;
      }
      // destinations need slightly less topPadding
      if (!chevronDisabled) {
        return 1;
      }
    }

    return undefined;
  };

  const getLineHeight = () => {
    // longer titles require special line heights to look proper
    if (isLongTitle) {
      if (isAndroid) {
        return '20px';
      }

      if (isWeb) {
        return '22px';
      }
    }

    return undefined;
  };

  return (
    <Pressable
      borderBottomWidth={setBottomBorder ? 2 : undefined}
      borderBottomColor={setBottomBorder ? athens : undefined}
      marginBottom={isDesktop ? 3 : undefined}
      paddingLeft={5}
      paddingY={2}
      justifyContent="center"
      paddingRight={!isDesktop && !active ? 5 : 0}
      height={isDesktop ? '40px' : '70px'}
      borderRadius={isDesktop ? '4px' : undefined}
      onHoverIn={handleHoverIn}
      onHoverOut={handleHoverOut}
      backgroundColor={hovering || active ? ghostWhite : undefined}
      disabled={disabled}
      opacity={disabled ? 0.5 : 1}
      onPress={onPress}>
      <View
        flexDirection="row"
        alignItems="center"
        paddingRight={chevronDisabled && isDesktop ? 5 : undefined}>
        {active && (
          <View marginRight={2}>
            <Icon
              name="check-circle"
              color={caesarRewards}
              size={theme.fontSizes[5]}
              solid
            />
          </View>
        )}
        <View flexDirection="row" alignItems="center" flex={1}>
          <Text
            testID="filter-list-item-title"
            fontSize={3}
            color={tuna}
            fontWeight={active ? 700 : 400}
            letterSpacing="1px"
            ellipsizeMode="tail"
            paddingTop={getPaddingTop()}
            textAlign="left"
            lineHeight={getLineHeight()}>
            {title?.toUpperCase()}
            {isDesktop ? '' : ' '}
            {count !== undefined && (
              <Text
                testID="filter-list-item-count"
                fontSize="10px"
                color={tuna}
                marginLeft={1}
                fontWeight={active ? 700 : 400}>
                ({count})
              </Text>
            )}
          </Text>
        </View>
        {!chevronDisabled && !isDesktop && !active && (
          <Icon
            name="chevron-right"
            size={theme.fontSizes[4]}
            solid
            light={false}
          />
        )}
      </View>
    </Pressable>
  );
};

export default OfferFilterListItem;
